import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { User } from 'src/app/shared/interfaces/user.interface';
import { MembersService } from '../members.service';
import { MatDialog } from '@angular/material/dialog';
import { DialogComponent } from 'src/app/components/dialog/dialog.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { environment } from 'src/environments/environment';
import { LoaderService } from 'src/app/components/loader/service/loader.service';
import { UserService } from 'src/app/account/services/user.service';

/**
 * @title Basic use of `<table mat-table>`
 */

@Component({
  selector: 'app-member-list',
  templateUrl: './member-list.component.html',
  styleUrls: ['./member-list.component.css'],
})
export class MemberListComponent {
  constructor(
    private memberService: MembersService,
    private router: Router,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private loadService: LoaderService
  ) {}

  displayedColumns: string[] = ['position', 'name', 'email', 'actions'];

  searchValue = '';
  members: User[] = [];
  showLoader: Boolean = false;
  paginate = {
    page: 1,
    limit: 10,
    lastPage: null,
  };
  @ViewChild(MatPaginator) paginator: MatPaginator;

  ngOnInit() {
    this.getMembers(this.paginate);
  }

  delete(id: string, name: string): void {
    const dialogRef = this.dialog.open(DialogComponent, {
      width: '400px',
      height: '250px',
      data: {
        title: 'Excluir',
        text: ' Deseja remover o usuário ? ',
        name: name,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.memberService
          .deleteUser(id)
          .then((res: any) => {
            this.snackBar.open(res.message, null, {
              duration: 4000,
            });

            this.getMembers(this.paginate);
          })
          .catch((err: any) => {
            this.snackBar.open(err.error.message || 'Algo de errado aconteçeu');
          });
      }
    });
  }

  async scroll(event) {
    if (event == this.members.length - 5 && this.members.length !== 0 && this.paginate.page < this.paginate.lastPage) {
      this.paginate.page++;
      this.getMembers(this.paginate);
    }
  }

  getMembers(paginate): void {
    this.loadService.showLoader();
    this.memberService
      .get(paginate)
      .then((res) => {
        this.loadService.closeLoader();
        this.members = this.members.concat(res.data);
        this.paginate.lastPage = res?.lastPage;
      })
      .catch((err) => {
        this.loadService.closeLoader();
      });
  }

  openEdit(id: number): void {
    this.router.navigateByUrl('membro/' + id);
  }

  search($val) {
    this.showLoader = true;
    this.memberService.searchMember($val).then((res) => {
      this.members = res;
      this.showLoader = false;
    });
  }

  getAvatar(memberAvatar: any): any {
    if (!memberAvatar) {
      return environment.endPointApi + 'user/avatar/default-user.png';
    } else {
      return environment.endPointApi + 'user/avatar/' + memberAvatar.file_name;
    }
  }

  remuveUser(id: string) {
    this.memberService.deleteUser(id).then((res) => {});
  }
}
